import { gql } from "graphql-request";

export const dataRequestListQuery = gql`
  query DataRequestList($workspaceId: String!) {
    dataRequestList(workspaceId: $workspaceId) {
      id
      title
      dueDate
      status
      workspaceId
      createdById
      fieldSelection
      createdAt
      updatedAt
      createdBy {
        id
        fullname
      }
      entityRequests {
        id
        entityId
        entityType
        entityTitle
        assigneeId
        taskId
        status
        assignee {
          id
          email
          fullname
        }
      }
    }
  }
`;

export const dataRequestDetailQuery = gql`
  query DataRequestDetail($id: String!, $workspaceId: String!) {
    dataRequest(id: $id, workspaceId: $workspaceId) {
      id
      title
      dueDate
      status
      workspaceId
      createdById
      fieldSelection
      enableDocuments
      freeTextQuestions {
        id
        label
      }
      createdAt
      updatedAt
      createdBy {
        id
        fullname
      }
      entityRequests {
        id
        entityId
        entityType
        entityTitle
        assigneeId
        taskId
        status
        freeTextAnswers
        assignee {
          id
          email
          fullname
        }
        fieldResponses {
          id
          fieldKey
          newValue
          notPossible
          comment
        }
      }
    }
  }
`;

export const dataRequestEntityDetailQuery = gql`
  query DataRequestEntityDetail($id: String!) {
    dataRequestEntity(id: $id) {
      id
      entityId
      entityType
      entityTitle
      assigneeId
      taskId
      status
      freeTextAnswers
      currentFieldValues
      dataRequest {
        id
        title
        status
        dueDate
        fieldSelection
        enableDocuments
        freeTextQuestions {
          id
          label
        }
      }
      assignee {
        id
        email
        fullname
      }
      fieldResponses {
        id
        fieldKey
        newValue
        notPossible
        comment
      }
    }
  }
`;

export const createDataRequestMutation = gql`
  mutation CreateDataRequest($input: CreateDataRequestInput!) {
    createDataRequest(input: $input) {
      id
      title
      status
      createdAt
    }
  }
`;

export const saveFieldResponseMutation = gql`
  mutation SaveFieldResponse($input: SaveFieldResponseInput!) {
    saveFieldResponse(input: $input) {
      id
      fieldKey
      newValue
      notPossible
      comment
    }
  }
`;

export const saveDataRequestEntityFreeTextMutation = gql`
  mutation SaveDataRequestEntityFreeText($input: SaveDataRequestEntityFreeTextInput!) {
    saveDataRequestEntityFreeText(input: $input) {
      id
      freeTextAnswers
    }
  }
`;

export const submitDataRequestEntityMutation = gql`
  mutation SubmitDataRequestEntity($id: String!) {
    submitDataRequestEntity(id: $id) {
      id
      entityId
      entityType
      status
      fieldResponses {
        id
        fieldKey
        newValue
        notPossible
        comment
      }
    }
  }
`;

export const sendDataRequestReminderMutation = gql`
  mutation SendDataRequestReminder($id: String!, $workspaceId: String!) {
    sendDataRequestReminder(id: $id, workspaceId: $workspaceId)
  }
`;

export const closeDataRequestMutation = gql`
  mutation CloseDataRequest($id: String!, $workspaceId: String!) {
    closeDataRequest(id: $id, workspaceId: $workspaceId) {
      id
      status
    }
  }
`;

export const deleteDataRequestMutation = gql`
  mutation DeleteDataRequest($id: String!, $workspaceId: String!) {
    deleteDataRequest(id: $id, workspaceId: $workspaceId) {
      id
    }
  }
`;
